import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './SignIn.css';
import axios from 'axios';
import config from '../includes/ConfigFile';
import { useAuth0 } from "@auth0/auth0-react"; // ✅ Auth0 import
import { FcGoogle } from "react-icons/fc";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // ✅ Auth0 hook
  const { loginWithRedirect, isAuthenticated, user } = useAuth0();

  // 🔹 Normal email/password login (your existing Laravel API)
  const collectData = async () => {
    try {
      const response = await axios.post(`${config.BASE_URL}/api/signin`, {
        email,
        password,
      });

      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
        navigate('/');
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Login failed. Please try again.');
    }
  };

  // 🔹 When Auth0 login succeeds, store user info
//   useEffect(() => {
//     if (isAuthenticated && user) {
//       localStorage.setItem('user', JSON.stringify(user));
//       navigate('/');
//     }
//   }, [isAuthenticated, user, navigate]);
useEffect(() => {
  if (isAuthenticated && user) {
    localStorage.setItem('user', JSON.stringify(user));

    // Send user to backend to save in DB
    axios.post(`${config.BASE_URL}api/google-login`, user)
      .then((res) => {
        console.log('✅ Auth0 user synced:', res.data);
        localStorage.setItem('user', JSON.stringify(res.data.user)); // Store DB user
        navigate('/');
      })
      .catch((err) => {
        console.error('❌ Backend Auth0 save failed:', err);
      });
  }
}, [isAuthenticated, user, navigate]);



  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sign In</title>
        <meta name="description" content="Login to your account" />
      </Helmet>

      <Container className="signin-container">
        <Row className="justify-content-center">
          <Col md={8} lg={5}>
            <Card className="signin-card">
              <Card.Body>
                <div className="text-center mb-4">
                  <h2 className="signin-title">Welcome Back</h2>
                  <p className="signin-subtitle">Sign in to continue reading</p>
                </div>

                {/* Normal Email/Password Login */}
                <form>
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Enter Email"
                    />
                    <label htmlFor="email">Email</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type="password"
                      placeholder="Enter Password"
                    />
                    <label htmlFor="password">Password</label>
                  </div>

                  <div className="form-floating">
                    <button
                      type="button"
                      onClick={collectData}
                      className="btn btn-primary"
                    >
                      Sign In
                    </button>
                  </div>
                </form>

                {/* ✅ Auth0 Login (Google & others) */}
                <div className="mt-3 text-center">
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => loginWithRedirect()}
                  >
                    <FcGoogle size={20} />  Continue with Google
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SignIn;
